module.exports = __webpack_public_path__ + "img/logo.c6f19104.png";